import { useNavigate, useParams } from 'react-router-dom';
import { ButtonMantine, Center, MobileBottomButton, NoDataMessageCard, Stack } from 'ui';

const NoAccess = () => {
  const { uuid } = useParams();

  const navigate = useNavigate();

  return (
    <>
      <Stack>
        <NoDataMessageCard
          title="You do not have access to this directory."
          message="Please reach out to your administrator for access."
        />

        <Center visibleFrom="md">
          <ButtonMantine variant="outline" onClick={() => navigate(`/causes/${uuid}`)}>
            Go to Cause Page
          </ButtonMantine>
        </Center>
      </Stack>

      <MobileBottomButton>
        <ButtonMantine variant="outline" onClick={() => navigate(`/causes/${uuid}`)}>
          Go to Cause Page
        </ButtonMantine>
      </MobileBottomButton>
    </>
  );
};

export { NoAccess };
